<template>
    <div style="height: 15px; justify-content: center; align-items: center;">
		<template>
			<el-select  @hook:mounted="removeReadOnly" @visible-change="removeReadOnly" 
				v-model="innerValue"
				filterable
				:remote="true"
				:likeQuery="false"
				@change="changeSelect"
				:clearable="clearable"
				:multiple="multiple"
				:remote-method="fetchOptions"
				size="small"
				popper-class="productGroupSelector"
				:placeholder="placeholder"
				ref="iosSelect"
			>
			
				<el-option-group class="productGroupSelector-group" v-for="group in localOptions" :key="group.label" :label="group.label">
					
					<div v-if="multiple">
						<div>
							<el-checkbox v-model="group.checked" @change="selectAll($event, group.id)" :indeterminate="group.isIndeterminate"></el-checkbox>
						</div>
						
						<div>
							<el-option
								class="productGroupSelector-option"
								v-for="(item,index) in group.options"
								:key="index"
								:label="item.label"
								:value="item"
							></el-option>
						</div>
					</div>

					<div v-else>
						<el-option
							class="productGroupSelector-option"
							v-for="(item,index) in group.options"
							:key="index"
							:label="item.label"
							:value="item"
						></el-option>
					</div>
					
				</el-option-group>
			</el-select>

		</template>
    </div>
</template>
<script>

import $ from 'jquery';
import {getRequest} from "@/api/api";
export default {
    name: 'LiloGroupSelect',
    model: {
        prop: 'value',
        event: 'change'
    },
    props: {
        value: {
            type: [String, Array],
            default: () => []
        },
        options: {
            type: Array,
            default: () => []
        },
        placeholder: {
            type: String,
            default: '请选择'
        },
        multiple: {
            type: Boolean,
            default: false
        },
        clearable: {
            type: Boolean,
            default: false
        },
        collapseTags: {
            type: Boolean,
            default: false
        },
        likeQuery: {
            type: Boolean,
            default: false
        },
        searchApi: {
            type: String,
            default: '' // 后端搜索API地址
        }
    },
    data() {
        return {
			innerValue: this.value,
			inputValue: ''  ,// 添加这一行来定义 inputValue
			selectedOption: '',
            // searchQuery: '',
			filteredOptions: [],
            loading: false,
            allOptions: [], // 存储所有后端返回的选项，用于筛选
			localOptions: [...this.options], // 新增属性，用于存储当前选项
			groupSelectOptions2: [
				{
					id: 1,
					label: '超期',
					options: [
						{
							value: 'cqwbj',
							label: '超期未办结'
						},
						{
							value: 'ycq',
							label: '已超期'
						}
					]
				},
				{
					id: 2,
					label: '按天',
					options: [
						{
							value: 't1',
							label: '1天'
						},
						{
							value: 't2',
							label: '2天'
						}
					]
				},
				{
					id: 3,
					label: '按小时',
					options: [
						{
							value: 'h1',
							label: '1小时'
						},
						{
							value: 'h2',
							label: '2小时'
						}
					]
				}
			],
			isDropdownVisible: false, // 控制下拉列表的显示状态(默认收起)隐藏
        };
    },
    mounted() {
        this.innerValue = this.value;
		this.allOptions = [...this.options, ...this.groupSelectOptions2]; // 初始化所有选项
		this.filteredOptions = [...this.options]; // 初始化过滤后的选项
		this.$refs.iosSelect?.$el.querySelector('.el-input__inner').removeAttribute("readOnly");
		this.fetchOptions("");
    },
    watch: {
		value(newVal, odlVal) {
			this.innerValue = newVal;
			console.log("当前输入值或选择值：", this.innerValue)
		},
        searchQuery(newVal) {
			console.log("监听查询输入：", newVal)
			this.fetchOptions(newVal);
        }
    },
    methods: {
		// 模拟后端查询，直接返回 groupSelectOptions2
		fetchOptions(queryString="") {
		  console.log("调用后端，请求数据....查询条件：【"+queryString+"】查询接口为："+this.searchApi)
		  if (this.loading) return;
		  this.loading = true;
		  try {
			// 此处模拟为直接返回 groupSelectOptions2，实际应调用后端API
			this.allOptions = [...this.options, ...this.groupSelectOptions2]; // 合并原始选项和后端返回的选项（去重应在后端处理或此处额外处理）
			let param = {}
			if(this.likeQuery && queryString) param.query = '%'+queryString+'%';
			console.log("param:", param)
			this.getRequest(this.searchApi, param).then(resp =>{
				if (resp){
					this.localOptions = [...resp];
					// console.log("调用后端，返回结果："+JSON.stringify(resp))
				}
			});
			// this.localOptions = [...this.groupSelectOptions2]; // 更新 localOptions 而不是 this.options
			// this.filteredOptions = this.filterOptionsByQuery(this.allOptions, queryString);
			// console.log("调用后端，数据处理结束。。。")
		  } catch (error) {
			// console.error('搜索失败:', error);
		  } finally {
			this.loading = false;
		  }
		},
		
		async query(queryString){
			console.log("async query(queryString)：", queryString)
			if(this.likeQuery) queryString = '%'+queryString+'%';
			this.getRequest(this.searchApi, {query: queryString}).then(resp =>{
				if (resp){
					this.localOptions = [...resp];
				}
			});
		},
		
		filterOptionsByQuery(options, query) {
			return this.allOptions.reduce((acc, group) => {
				const filteredGroup = { ...group, options: group.options.filter(option => option.label.toLowerCase().includes(query.toLowerCase())) };
				// const filteredGroup = { ...group, options: group.options.filter(option => option.label.includes(query)) };
				if (filteredGroup.options.length > 0) {
					acc.push(filteredGroup);
				}
				return acc;
			}, []);
		},
		
		selectAll(val, id) {
            const selectOption = this.options.find(f => f.id === id);
            const arr = selectOption.options.map(m => m.value);
            if (val) {
                if((typeof this.innerValue !== 'object') || this.innerValue.constructor !== Array) {
                    this.innerValue = [];
                }
                arr.forEach(item => {
                    if (!this.innerValue.includes(item)) {
                        this.innerValue.push(item);
                    }
                });
            } else {
                this.innerValue.forEach((item, index) => {
                    if (arr.includes(item)) {
                        this.innerValue.splice(index, 1, '');
                    }
                });
            }
            this.innerValue = this.innerValue.filter(f => f !== '');
            if (selectOption.checked) {
                selectOption.isIndeterminate = false;
            }
            this.$emit('change', this.innerValue);
        },
		
        changeSelect(val) {
			console.log("选项变更值："+val)
            if (this.multiple) {
                this.options.forEach(item => {
                    const arr = item.options.map(m => m.value);
                    item.isIndeterminate = arr.some(v => {
                        return val.some(s => s === v);
                    });
                    item.checked = arr.every(v => {
                        return val.some(s => s === v);
                    });
                    if (item.checked) {
                        item.isIndeterminate = false;
                    }
                });
                this.$emit('change', this.innerValue);
            } else {
                this.$emit('change', val);
            }
			
			// iPad 兼容：延迟 50ms 后失焦（确保键盘能正常关闭）
			setTimeout(() => {
			  const input = this.$refs.iosSelect?.$el?.querySelector('input');
			  input?.blur();
			}, 50);
		},
		removeReadOnly() {// 解决：el-select 在 ios 输入框无法唤出 键盘的问题
		  this.$nextTick(() => {
		    const input = this.$refs.iosSelect?.$el.querySelector('.el-input__inner');
		    input.removeAttribute('readonly');
		  });
		}
    }
};
</script>

<style lang="scss" scoped>
	
.productGroupSelector {
	min-width: initial !important;
	max-width: 340px;
}

::v-deep {
	.el-select-group {
		max-width: 340px;
		display: flex;
		flex-wrap: wrap;
		justify-content: start;
		padding: 0px 10px;
	}

	.el-select-group__title {
		padding-left: 20px;
		font-size: 12px;
	}
}

.productGroupSelector-group {
	padding-top: 5px;
	display: flex;
	// align-items: center;
	// flex-wrap: wrap;
	// width: 400px;
	padding-bottom: 5px;
	flex-direction: column;
	margin: 0 5px;

	// &:not(:last-child) {
	// 	border-bottom: 1px solid rgba($color: #000000, $alpha: 0.1);
	// }

	&::after {
		display: none;
	}
}

.productGroupSelector-option {
	display: inline-flex;
	align-items: center;
	flex-wrap: wrap;
}

// .productGroupSelector {
// .el-scrollbar__view .el-select-dropdown__list {
//     display: flex;
//     flex-wrap: wrap;
//     justify-content: space-between;
//     align-items: baseline;
//     padding-top: 0;
//     overflow-x: hidden;
// }
// .el-select-dropdown__wrap .el-scrollbar__wrap {
//     max-height: 650px;
// }
// }


</style>
